
import { defineComponent, ref } from 'vue';
import { AuthModule } from '@/store/auth';
import { signupWithGeotab } from '@/api/accidentplan-api';
import { ElMessage } from 'element-plus';
import { SetupStates } from './setup-states';

export default defineComponent({
  emits: ['next'],
  setup(props, context) {
    const getStarted = () => context.emit('next', SetupStates.Welcome);

    return { getStarted };
  },
});
